import { ActionTree } from "vuex";
import { IState } from "../../../IState";
import { IUser } from "../IUser";
import { Id } from "@gemma/typescript-types";
import { WireEntities } from "@timesheets/common";

export const actions: ActionTree<IUser, IState> = {
  setAllowUploads({ commit }, { allowUploads, recruitmentAgency }: { allowUploads: boolean; recruitmentAgency: WireEntities.Roles.IRecruitmentAgencyRole<unknown> | Id<string> }) {
    commit("mutateAllowUploads", { allowUploads, recruitmentAgency });
  },
};
